import { Link } from "react-router-dom";
import { Linkedin, Instagram, Facebook, Mail, Phone, MapPin, KeyRound } from "lucide-react";
import { SITE } from "../config/site";
import { useLanguage } from "../i18n/LanguageContext";

export const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer data-testid="site-footer" className="bg-ebony text-[#B9BDB4]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <p className="font-serif text-2xl font-semibold text-alabaster">
              {SITE.shortName}
            </p>
            <p className="text-sm leading-relaxed mt-6 max-w-sm text-[#9AA096]">
              {t("site.positioning")}
            </p>
            <div className="flex items-center gap-3 mt-8" data-testid="footer-social-links">
              <a
                href={SITE.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin-link"
                aria-label="LinkedIn"
                className="inline-flex items-center justify-center w-11 h-11 border border-[#3A3F38] text-alabaster hover:border-gold hover:text-gold transition-colors duration-300"
              >
                <Linkedin size={15} />
              </a>
              <a
                href={SITE.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                aria-label="Instagram"
                className="inline-flex items-center justify-center w-11 h-11 border border-[#3A3F38] text-alabaster hover:border-gold hover:text-gold transition-colors duration-300"
              >
                <Instagram size={15} />
              </a>
              <a
                href={SITE.facebook}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook-link"
                aria-label="Facebook"
                className="inline-flex items-center justify-center w-11 h-11 border border-[#3A3F38] text-alabaster hover:border-gold hover:text-gold transition-colors duration-300"
              >
                <Facebook size={15} />
              </a>
            </div>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#7C8B74] mb-6">
              {t("footer.contacts")}
            </p>
            <ul className="space-y-4 text-sm">
              <li>
                <a
                  href={`mailto:${SITE.email}`}
                  data-testid="footer-email-link"
                  className="flex items-center gap-3 hover:text-alabaster transition-colors"
                >
                  <Mail size={15} className="text-gold" /> {SITE.email}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${SITE.phone.replace(/\s/g, "")}`}
                  data-testid="footer-phone-link"
                  className="flex items-center gap-3 hover:text-alabaster transition-colors"
                >
                  <Phone size={15} className="text-gold" /> {SITE.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin size={15} className="text-gold" /> {t("footer.offices")} — {SITE.offices}
              </li>
            </ul>
            <p className="text-xs text-[#6C7067] mt-8 leading-relaxed">{t("site.oa")}</p>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#7C8B74] mb-6">
              {t("footer.nav")}
            </p>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" data-testid="footer-nav-home" className="hover:text-alabaster transition-colors">{t("nav.home")}</Link></li>
              <li><Link to="/sobre" data-testid="footer-nav-about" className="hover:text-alabaster transition-colors">{t("nav.about")}</Link></li>
              <li><Link to="/blog" data-testid="footer-nav-blog" className="hover:text-alabaster transition-colors">{t("nav.blog")}</Link></li>
              <li><Link to="/agendamento" data-testid="footer-nav-booking" className="hover:text-alabaster transition-colors">{t("nav.booking")}</Link></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-[#2A2E28]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#6C7067]">
            © {new Date().getFullYear()} {SITE.name} — {t("footer.rights")}
          </p>
          <Link
            to="/admin/login"
            data-testid="nav-admin-link"
            className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-[#6C7067] hover:text-gold transition-colors"
          >
            <KeyRound size={12} /> {t("footer.admin")}
          </Link>
        </div>
      </div>
    </footer>
  );
};
